import { render, staticRenderFns } from "./add.vue?vue&type=template&id=97f75342&scoped=true&lang=pug&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=97f75342&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f75342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f75342')) {
      api.createRecord('97f75342', component.options)
    } else {
      api.reload('97f75342', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=97f75342&scoped=true&lang=pug&", function () {
      api.rerender('97f75342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkin/add.vue"
export default component.exports